import { render, staticRenderFns } from "./navigation-bar.vue?vue&type=template&id=1652b8a4"
import script from "./navigation-bar.vue?vue&type=script&lang=ts"
export * from "./navigation-bar.vue?vue&type=script&lang=ts"
import style0 from "./navigation-bar.vue?vue&type=style&index=0&id=1652b8a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports